<script setup lang="ts">
import Logo from "@/components/icons/Logo.vue";
</script>

<template>
  <div class="fixed top-6 left-1/2 -translate-x-1/2 z-50 w-fit">
    <div class="rounded-full border p-2 bg-surface-50 dark:bg-surface-950">
      <nav
        class="rounded-full flex items-center gap-3.5 p-6 bg-surface-0 dark:bg-surface-900 shadow-[0px_28px_8px_0px_rgba(44,54,87,0.00),_0px_18px_7px_0px_rgba(44,54,87,0.01),_0px_10px_6px_0px_rgba(44,54,87,0.02),_0px_4px_4px_0px_rgba(44,54,87,0.03),_0px_1px_2px_0px_rgba(44,54,87,0.04)]"
      >
        <Logo class="mx-8" />
      </nav>
    </div>
  </div>
</template>
